export const isOnboardingFinished = (userInfo) => {
  if (process.env.REACT_APP_TYPE === "partner") {
    return !!userInfo?.onboarding_finished || !!userInfo?.new_onboarding_finished
  }

  return !!userInfo?.new_onboarding_finished
}
